import { reactive } from 'vue';
import { ConfirmModal } from '@wision/ui';

type Options = {
  type: 'alert' | 'confirm'
}

export default defineNuxtPlugin((nuxtApp) => {
  const defaultOptions: Options = { type: 'confirm' };

  const state = reactive({
    visible: false,
    title: '',
    message: '',
    options: defaultOptions,
    resolve: null as null | ((value: boolean) => void),
  });

  const close = (result: boolean) => {
    state.visible = false;
    state.resolve?.(result);
    state.resolve = null;
  };

  const confirm = (title: string, message: string) => {
    state.title = title;
    state.message = message;
    state.visible = true;
    state.options = { type: 'confirm' };

    return new Promise<boolean>((resolve) => {
      state.resolve = resolve;
    });
  };

  const alert = (title: string, message: string) => {
    state.title = title;
    state.message = message;
    state.visible = true;
    state.options = { type: 'alert' };

    return new Promise<boolean>((resolve) => {
      state.resolve = resolve;
    });
  };

  const GlobalConfirmWrapper = defineComponent({
    name: 'GlobalConfirmWrapper',
    setup() {
      return () =>
        h(ConfirmModal, {
          show: state.visible,
          message: state.message,
          title: state.title,
          options: state.options,
          onConfirm: (value: boolean) => close(value)
        });
    },
  });

  nuxtApp.vueApp.component('GlobalConfirmModal', GlobalConfirmWrapper);

  return {
    provide: {
      confirm,
      alert
    }
  };
});
